export default __webpack_public_path__ + "static/media/search.d0fbd66f.png";